/* ==========================================================================
   PRODUCT — variant selection and gallery

   Variants are matched from the option values the shopper picked. Anything
   unavailable is disabled rather than hidden, so the shopper can see the size
   exists and is simply sold out — hiding it reads as "we don't make that".
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-product]');
  if (!root) return;

  function $(s) { return root.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  function money(n) { return '$' + Number(n).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}); }

  var variants = [];
  try { variants = JSON.parse($('[data-variants]').textContent); } catch (e) { variants = []; }

  var chosen = { metal: null, size: null };
  var ringSize = $('[data-ring-size]');
  if (ringSize) ringSize.addEventListener('change', paint);

  function find() {
    var pool = variants.filter(function (v) {
      if (chosen.metal && v.metal !== chosen.metal) return false;
      if (chosen.size && String(v.size) !== String(chosen.size)) return false;
      return true;
    });
    // Before a size is picked, represent the metal with an AVAILABLE variant.
    // Falling back to pool[0] made a metal look sold out because its first
    // size happened to be out of stock.
    return pool.filter(function (v) { return v.available; })[0] || pool[0] || null;
  }

  /* A size is offered only if some variant in the chosen metal has it. */
  function sizeAvailable(size) {
    return variants.some(function (v) {
      return String(v.size) === String(size) &&
        (!chosen.metal || v.metal === chosen.metal) && v.available;
    });
  }

  function paint() {
    var v = find();

    if (v) {
      $('[data-price]').innerHTML = money(v.price) +
        (v.available ? '' : ' <small>— sold out</small>');
      var input = $('[data-variant-id]');
      if (input) input.value = v.id;
    }

    var metalOut = $('[data-metal-value]');
    if (metalOut) metalOut.textContent = chosen.metal || 'Choose a metal';
    var sizeOut = $('[data-size-value]');
    if (sizeOut) sizeOut.textContent = chosen.size ? 'Size ' + chosen.size : 'Choose a size';

    $$('[data-size]').forEach(function (b) {
      var s = b.getAttribute('data-size');
      b.disabled = !sizeAvailable(s);
      b.setAttribute('aria-pressed', String(String(chosen.size) === s));
      // Clear a selection that the new metal cannot satisfy.
      if (b.disabled && String(chosen.size) === s) chosen.size = null;
    });

    var btn = $('[data-add]');
    if (btn) {
      var ready = !!v && v.available && (!$$('[data-size]').length || chosen.size) && (!ringSize || ringSize.value);
      btn.disabled = !ready;
      btn.textContent = !v || !v.available ? 'Sold out'
        : ready ? 'Add to cart'
        : 'Select a size';
    }
  }

  $$('[data-opt-metal]').forEach(function (b) {
    b.addEventListener('click', function () {
      chosen.metal = b.getAttribute('data-opt-metal');
      $$('[data-opt-metal]').forEach(function (o) {
        o.setAttribute('aria-pressed', String(o === b));
      });
      paint();
    });
  });

  $$('[data-size]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      chosen.size = b.getAttribute('data-size');
      paint();
    });
  });

  /* Gallery */
  var stage = $('[data-stage]');
  $$('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      stage.innerHTML = t.innerHTML;
      $$('[data-thumb]').forEach(function (o) {
        o.setAttribute('aria-pressed', String(o === t));
      });
    });
  });

  // Preselect the first metal so the price is never ambiguous on arrival.
  var firstMetal = $('[data-opt-metal]');
  if (firstMetal) firstMetal.click(); else paint();
})();
